import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useState } from "react";

const DataTable = ({ 
  columns, 
  rows, 
  loading,
  totalRows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange 
}) => {

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        boxShadow: 3,
        borderRadius: 1,
      }}
    >
      <Table>
        <TableHead className="tableHeader">
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.field}>{column.headerName}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                <Box display="flex" justifyContent="center" alignItems="center" py={2}>
                  <CircularProgress />
                </Box>
              </TableCell>
            </TableRow>
          ) : rows?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data available.
              </TableCell>
            </TableRow>
          ) : (
            rows?.map((row) => (
              <TableRow key={row.id}>
                {columns?.map((column) => (
                  <TableCell key={column.field}>
                    {column.renderCell ? column?.renderCell(row) : row[column.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default DataTable;